import styled from 'styled-components'

export const ConfirmationModalContainer = styled.div`
  padding-top: 20px;
  color: ${({ theme }) => theme.FontColor};
  height: 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  h2 {
    font-weight: 600;
    font-size: 20px;
    line-height: 24px;
    text-align: center;
    margin-bottom: 20px;
  }
  p {
    text-align: justify;
  }
`

export const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
`

export const BigAnimationContainer = styled.div`
  border-radius: 5px;
  overflow: hidden;
  margin-bottom: 20px;
`
